module.exports = __webpack_public_path__ + "static/media/warningIcon.0cec102e.gif";